import React, { useState, useEffect } from "react";
import { ENV } from "../../config/config";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import { useGetRoleQuery } from "../../redux/api";
import { useGetSlidersQuery, useGetSliderQuery, useCreateSliderMutation, useEditSliderMutation, useDeleteSliderMutation, useGetGalleryQuery, useListContentQuery, useListEventsQuery } from "../../redux/api";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import localeInfo from "rc-pagination/lib/locale/en_US";
import {
  Button,
  Card,
  Form,
  Table,
  Container,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import { FaPlus, FaCheck, FaTimes, FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { useSelector, useDispatch } from "react-redux";
import SliderModal from "./sliderModal";
import validator from "validator";
import Select from "react-select";
import GalleryModal from "components/Gallery/galleryModal";
import ContentModal from "./contentModal";
import EventModal from "./eventModal";
var CryptoJS = require("crypto-js");
const { objectToQueryString, decimalNumberValidator } = ENV;

const Slider = () => {
  const initialSlider = {
    image: "",
    url: "",
    isActive: true,
    isExternal: false,
    contentId: null,
    eventId: null,
  };
  // const dispatch = useDispatch();
  const [sliders, setSliders] = useState([]);
  const [slider, setSlider] = useState(initialSlider);
  const [id, setId] = useState("");
  const [qs, setQs] = useState("");
  const { data: slidersData, isLoading: isListLoading, isFetching: isListFetching, refetch } = useGetSlidersQuery(qs);
  const { data: sliderData, isLoading: isSliderLoading } = useGetSliderQuery(id, { skip: !id });
  const [createSliderMut, { isLoading: isCreatingSlider }] = useCreateSliderMutation();
  const [editSliderMut, { isLoading: isEditingSlider }] = useEditSliderMutation();
  const [deleteSliderMut, { isLoading: isDeletingSlider }] = useDeleteSliderMutation();
  const [sliderErrors, setSliderErrors] = useState({
    url: "",
    image: "",
    contentId: "",
    eventId: "",
  });
  const [pagination, setPagination] = useState(null);
  const [resetButton, setResetButton] = useState(false);
  const [permissions, setPermissions] = useState({});
  
  const [filters, setFilters] = useState({
    url: "",
    isExternal: "",
    isActive: "",
  });
  const [modalType, setModalType] = useState(0);
  const [openModal, setOpenModal] = useState(false);

  const { error } = useSelector((state) => state.error);
  // const rolesSelector = useSelector((state) => state.role.getRoleRes);
  // const sliderSelector = useSelector((state) => state.slider);

  // Gallery Model
  const [gallery, setGallery] = useState([]);
  const [isGalleryOpenModal, setGalleryOpenModal] = useState(false);
  const [galleryPagination, setGalleryPagination] = useState(null);
  const [galleryFilters, setGalleryFilters] = useState({
    name: "",
  });
  const [galleryQs, setGalleryQs] = useState("");
  const { data: galleryData, isLoading: isGalleryLoading, isFetching: isGalleryFetching } = useGetGalleryQuery(galleryQs, { skip: !galleryQs });
  const [imageView, setImageView] = useState("");
  const [galleryResetButton, setGalleryResetButton] = useState(false);
  // const gallerySelector = useSelector((state) => state.gallery);

  // Content Model
  const [content, setContent] = useState([]);
  const [isContentOpenModal, setContentOpenModal] = useState(false);
  const [contentPagination, setContentPagination] = useState(null);
  const [contentFilters, setContentFilters] = useState({
    title: "",
    limit: 12,
  });
  const [contentQs, setContentQs] = useState("");
  const { data: contentData, isLoading: isContentLoading } = useListContentQuery(contentQs, { skip: !contentQs });

  // Event Model
  const [events, setEvents] = useState([]);
  const [isEventOpenModal, setEventOpenModal] = useState(false);
  const [eventPagination, setEventPagination] = useState(null);
  const [eventFilters, setEventFilters] = useState({
    title: "",
    limit: 12,
  });
  const [eventQs, setEventQs] = useState("");
  const { data: eventsData, isLoading: isEventsLoading, isFetching: isEventsFetching } = useListEventsQuery(eventQs, { skip: !eventQs });

  useEffect(() => {
    if (eventsData) {
      console.log("eventsData fetched:", eventsData);
    }
  }, [eventsData]);

  const isGlobalLoading = isListLoading || isListFetching || isSliderLoading || isGalleryLoading || isGalleryFetching || isContentLoading || isCreatingSlider || isEditingSlider || isDeletingSlider || isEventsLoading;
  const [contentTitle, setContentTitle] = useState("");
  const [eventTitle, setEventTitle] = useState("");
  const [contentResetButton, setContentResetButton] = useState(false);
  const [eventResetButton, setEventResetButton] = useState(false);
  // const contentSelector = useSelector((state) => state.content);
  useEffect(() => {
    window.scroll(0, 0);
    if (localStorage.getItem("userID")) {
      // query runs automatically
    }
  }, []);
  const roleEncrypted = localStorage.getItem("role");
  const roleDecrypted = roleEncrypted
    ? CryptoJS.AES.decrypt(roleEncrypted, ENV.secretKey).toString(
        CryptoJS.enc.Utf8
      )
    : "";
  const { data: roleData } = useGetRoleQuery(roleDecrypted, { skip: !roleEncrypted });

  useEffect(() => {
    if (roleData && roleData.role?.permissions) {
      if (typeof roleData.role.permissions === 'string') {
        setPermissions(JSON.parse(roleData.role.permissions));
      } else {
        setPermissions(roleData.role.permissions);
      }
    }
  }, [roleData]);

  // Removed manual loader handling - RTK manages loading

  useEffect(() => {
    if (slidersData) {
      const s = slidersData.sliders ?? slidersData.data ?? slidersData;
      const pag = slidersData.pagination ?? null;
      setSliders(s);
      setPagination(pag);
    }
  }, [slidersData]);

  useEffect(() => {
    if (sliderData && id) {
      const s = sliderData.slider ?? sliderData;
      setSlider(s);
      if (s.Content) {
        setContentTitle(s.Content.title || s.Content.url || "");
      }
      if (s.Event) {
        setEventTitle(s.Event.title || "");
      }
    }
  }, [sliderData, id]);

  useEffect(() => {
    if (!isListLoading && qs) {
      refetch();
    }
  }, [isListLoading]);

  useEffect(() => {
    if (galleryData) {
      const g = galleryData.gallery ?? galleryData.data ?? galleryData;
      const pag = galleryData.pagination ?? null;
      setGallery(g);
      setGalleryPagination(pag);
    }
  }, [galleryData]);

  useEffect(() => {
    if (contentData) {
      const c = contentData.contents ?? contentData.data ?? contentData;
      const pag = contentData.pagination ?? null;
      setContent(c);
      setContentPagination(pag);
    }
  }, [contentData]);

  useEffect(() => {
    if (eventsData) {
      const e = eventsData.events ?? eventsData.data ?? eventsData;
      const pag = eventsData.pagination ?? null;
      setEvents(e);
      setEventPagination(pag);
    }
  }, [eventsData]);

  const onPageChange = async (page) => {
    const queryString = objectToQueryString({ page, ...filters });
    setQs(queryString);
  };

  const applyFilters = () => {
    if (filters && (filters.url || filters.isActive || filters.isExternal)) {
      setResetButton(true);
      const queryString = objectToQueryString({ page: 1, limit: 10, ...filters });
      setQs(queryString);
    } else {
      toast.error("Search fields are empty.", {
        toastId: "FIELD_REQUIRED",
      });
    }
  };

  const deleteHandler = (catId) => {
    Swal.fire({
      title: "Are you sure you want to delete?",
      html: "If you delete an item, it will lost permanently.",
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then(async (result) => {
      if (result.value) {
        (async () => {
          await deleteSliderMut(catId);
        })();
      }
    });
  };

  const reset = () => {
    setResetButton(false);
    setFilters({ url: "", isExternal: "", isActive: "" });
    setQs("");
  };

  const resetModalContent = () => {
    setSlider(initialSlider);
    setImageView();
    setContentTitle("");
    setEventTitle("");
  };
  const modalCloseHandler = () => {
    setOpenModal(!openModal);
    setModalType(0);
    setId("");
    resetModalContent();
  };

  const VALIDATION_ERROR_MESSAGES = {
    url: "Url field is required.",
    invalidUrl: "Url is invalid. Please enter a valid url.",
    contentId: "Content is required.",
    eventId: "Event is required.",
    image: "Image is required.",
  };

  const validateUrlField = (url) => {
    let isValid = true;

    if (validator.isEmpty(url)) {
      setSliderErrors((prevErrors) => ({
        ...prevErrors,
        url: VALIDATION_ERROR_MESSAGES.url,
      }));
      isValid = false;
    } else if (!validator.isURL(url)) {
      setSliderErrors((prevErrors) => ({
        ...prevErrors,
        url: VALIDATION_ERROR_MESSAGES.invalidUrl,
      }));
      isValid = false;
    } else {
      setSliderErrors((prevErrors) => ({
        ...prevErrors,
        url: "",
      }));
    }
    return isValid;
  };

  const validateField = (value, validator, errorMessage, field) => {
    if (validator(value)) {
      setSliderErrors((prevErrors) => ({
        ...prevErrors,
        [field]: errorMessage,
      }));
      return false;
    } else {
      setSliderErrors((prevErrors) => ({ ...prevErrors, [field]: "" }));
      return true;
    }
  };

  const submit = () => {
    let isValid = true;
    isValid &= validateField(
      String(slider.image),
      validator.isEmpty,
      VALIDATION_ERROR_MESSAGES.image,
      "image"
    );
    if (slider.isExternal) {
      isValid &= validateUrlField(slider.url);
    }
    if (!slider.isExternal) {
      if (slider.eventId) {
        isValid &= validateField(
          String(slider.eventId),
          validator.isEmpty,
          VALIDATION_ERROR_MESSAGES.eventId,
          "eventId"
        );
      } else {
        isValid &= validateField(
          String(slider.contentId),
          validator.isEmpty,
          VALIDATION_ERROR_MESSAGES.contentId,
          "contentId"
        );
      }
    }
    if (isValid) {
      const { Gallery, ...newSlider } = slider;
      (async () => {
        if (modalType === 2) {
          await createSliderMut(newSlider);
        } else {
          await editSliderMut(newSlider);
        }
        modalCloseHandler();
      })();
    }
  };

  const isAddViewEdit = (catId, mType) => {
    if (mType === 2) {
      resetModalContent();
      setId("");
    } else {
      setId(catId);
      const slider = sliders.find((s) => s.id === catId);
      if (slider) {
        setSlider(slider);
        if (slider.Content) {
          setContentTitle(slider.Content.title || slider.Content.url || "");
        }
        if (slider.Event) {
          setEventTitle(slider.Event.title || "");
        }
      }
    }
    setModalType(mType);
    setOpenModal(true);
  };

  const statusOptions = [
    { value: "1", label: "Active" },
    { value: "0", label: "Inactive" },
  ];

  const fetchContent = () => {
    const queryString = objectToQueryString({ limit: 12 });
    setContentQs(queryString);
    setContentOpenModal(true);
  };

  const setContentFn = (cnt) => {
    setSlider({ ...slider, contentId: cnt.id, eventId: null });
    setContentTitle(cnt.title);
    setSliderErrors((prevErrors) => ({ ...prevErrors, contentId: "", eventId: "" }));
  };

  // Event Functions
  const fetchEvents = () => {
    const queryString = objectToQueryString({ limit: 12 });
    setEventQs(queryString);
    setEventOpenModal(true);
  };

  const setEventFn = (evt) => {
    setSlider({ ...slider, eventId: evt.id, contentId: null });
    setEventTitle(evt.title);
    setSliderErrors((prevErrors) => ({ ...prevErrors, eventId: "", contentId: "" }));
  };

  // Gallery Functions
  const fetchGallery = () => {
    const queryString = objectToQueryString({ page: 1, limit: 12, isActive: true });
    setGalleryQs(queryString);
    setGalleryOpenModal(true);
  };

  const setImage = (img) => {
    setSlider((prevSlider) => {
      const { Gallery, ...rest } = prevSlider;
      return { ...rest, image: img.id };
    });
    setImageView(img.image);
    setSliderErrors((prevErrors) => ({ ...prevErrors, image: "" }));
  };

  const onGalleryPageChange = async (page) => {
    const queryString = objectToQueryString({ page, ...galleryFilters });
    setGalleryQs(queryString);
  };

  const onContentPageChange = async (page) => {
    const queryString = objectToQueryString({ page, ...contentFilters });
    setContentQs(queryString);
  };

  const onEventPageChange = async (page) => {
    const queryString = objectToQueryString({ page, ...eventFilters });
    setEventQs(queryString);
  };

  const galleryReset = () => {
    setGalleryResetButton(false);
    setGalleryFilters({ name: "" });
    setGalleryQs("");
  };

  const contentReset = () => {
    setContentResetButton(false);
    setContentFilters({ ...contentFilters, title: "" });
    const queryString = objectToQueryString({ ...contentFilters });
    setContentQs(queryString);
  };

  const eventReset = () => {
    setEventResetButton(false);
    setEventFilters({ ...eventFilters, title: "" });
    const queryString = objectToQueryString({ ...eventFilters });
    setEventQs(queryString);
  };

  const applyGalleryFilters = () => {
    if (galleryFilters && galleryFilters.name) {
      setGalleryResetButton(true);
      const queryString = objectToQueryString({ page: 1, limit: 10, ...galleryFilters });
      setGalleryQs(queryString);
    } else {
      toast.error("Search fields are empty.", {
        toastId: "FIELD_REQUIRED",
      });
    }
  };

  const applyContentFilters = () => {
    if (contentFilters && contentFilters.title) {
      setContentResetButton(true);
      const queryString = objectToQueryString({
        page: 1,
        ...contentFilters,
      });
      setContentQs(queryString);
    } else {
      toast.error("Search fields are empty.", {
        toastId: "FIELD_REQUIRED",
      });
    }
  };

  const applyEventFilters = () => {
    if (eventFilters && eventFilters.title) {
      setEventResetButton(true);
      const queryString = objectToQueryString({
        page: 1,
        ...eventFilters,
      });
      setEventQs(queryString);
    } else {
      toast.error("Search fields are empty.", {
        toastId: "FIELD_REQUIRED",
      });
    }
  };

  if (isGlobalLoading) {
    return <FullPageLoader />;
  }

  return (
    <>
      <Container fluid>
          <Row className="pb-3">
            <Col sm={12}>
              <Card className="filter-card">
                <Card.Header>
                  <div className="d-flex align-items-center justify-content-between table-head">
                    <Card.Title as="h4">Filters</Card.Title>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col xl={4} sm={6}>
                      <Form.Group>
                        <label>Search with url...</label>
                        <Form.Control
                          value={filters.url}
                          type="text"
                          placeholder="Search with url..."
                          onChange={(e) =>
                            setFilters({ ...filters, url: e.target.value })
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col xl={4} sm={6} className="search-wrap">
                      <label>Search with external url...</label>
                      <Form.Group>
                        <Select
                          classNamePrefix="triage-select"
                          placeholder="Select footer sliders..."
                          name="status"
                          options={statusOptions}
                          onChange={(e) =>
                            setFilters({
                              ...filters,
                              isExternal: e ? e.value : "",
                            })
                          }
                          value={statusOptions.filter(
                            (l) => l.value === filters.isExternal
                          )}
                          isClearable
                        />
                      </Form.Group>
                    </Col>
                    <Col xl={4} sm={6} className="search-wrap">
                      <label>Search with status...</label>
                      <Form.Group>
                        <Select
                          classNamePrefix="triage-select"
                          placeholder="Select sliders status..."
                          name="status"
                          options={statusOptions}
                          onChange={(e) =>
                            setFilters({
                              ...filters,
                              isActive: e ? e.value : "",
                            })
                          }
                          value={statusOptions.filter(
                            (l) => l.value === filters.isActive
                          )}
                          isClearable
                        />
                      </Form.Group>
                    </Col>

                    <Col xl={4} md={6}>
                      <Form.Group>
                        <Form.Label className="d-block mb-2">&nbsp;</Form.Label>
                        <div className="d-flex  filter-btns-holder">
                          <Button
                            className="btn-filled mr-3"
                            onClick={applyFilters}
                          >
                            Search
                          </Button>
                          {resetButton && (
                            <Button
                              variant="warning"
                              className="outline-button"
                              onClick={reset}
                            >
                              Reset
                            </Button>
                          )}
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col md="12">
              <Card className="table-big-boy">
                <Card.Header>
                  <div className="d-flex align-items-center justify-content-between table-head">
                    <Card.Title as="h4">Sliders</Card.Title>
                    {permissions && permissions?.addSlider && (
                      <Button
                        className="float-sm-right btn-filled d-flex align-items-center"
                        onClick={() => {
                          isAddViewEdit(null, 2);
                        }}
                      >
                        <span className="add-icon mr-2">
                          <FaPlus />
                        </span>
                        Add Slider
                      </Button>
                    )}
                  </div>
                </Card.Header>
                <Card.Body className="table-full-width">
                  <div className="table-responsive">
                    <Table className="table-bigboy">
                      <thead>
                        <tr>
                          <th className="text-center td-start">#</th>
                          <th className="td-type">URL</th>
                          <th className="td-type">Image</th>
                          <th className="td-type">External Url</th>
                          <th className="td-type">Status</th>
                          <th className="td-actions text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sliders && sliders.length ? (
                          sliders.map((slider, index) => {
                            return (
                              <tr key={index}>
                                <td className="text-center serial-col">
                                  {pagination &&
                                    pagination.limit * pagination.page -
                                      pagination.limit +
                                      index +
                                      1}
                                </td>
                                <td className="td-type">
                                  {slider.url
                                    ? slider.url
                                    : slider?.Content?.Category?.url +
                                      "/" +
                                      slider?.Content?.url}
                                </td>
                                <td>
                                  <img
                                    src={
                                      ENV.assetsUrl +
                                      "gallery/" +
                                      slider?.Gallery?.image
                                    }
                                    id="imageUploader"
                                    className="image-fluid"
                                    style={{ width: "30%", height: "30%" }}
                                    alt="gallery-image"
                                  />
                                </td>
                                <td className="td-type">
                                  {" "}
                                  {slider.isExternal ? (
                                    <span className="label label-success m-0 rounded-pill">
                                      <FaCheck />
                                    </span>
                                  ) : (
                                    <span className="label label-danger m-0 rounded-pill">
                                      <FaTimes />
                                    </span>
                                  )}{" "}
                                </td>
                                <td className="td-type">
                                  {" "}
                                  {slider.isActive ? (
                                    <span className="label label-success m-0">
                                      Active
                                    </span>
                                  ) : (
                                    <span className="label label-danger m-0">
                                      Inactive
                                    </span>
                                  )}{" "}
                                </td>

                                <td className="td-actions text-center">
                                  <ul className="list-unstyled mb-0">
                                    {/* {permissions && permissions.viewSlider && (
                                      <li className="d-inline-block align-top">
                                        <OverlayTrigger
                                          overlay={
                                            <Tooltip id="tooltip-436082023">
                                              {" "}
                                              View{" "}
                                            </Tooltip>
                                          }
                                          placement="left"
                                        >
                                          <Button
                                            className="btn-link btn-icon"
                                            type="button"
                                            variant="primary"
                                            // onClick={() => {
                                            //     isAddViewEdit(slider.id, 1)
                                            // }}
                                            onClick={() =>
                                              window.open(
                                                `${ENV.frontendUrl}${slider.url}`,
                                                "_blank"
                                              )
                                            }
                                          >
                                            <i className="fas fa-eye"></i>
                                          </Button>
                                        </OverlayTrigger>
                                      </li>
                                    )} */}
                                    {permissions && permissions.editSlider && (
                                      <li className="d-inline-block align-top">
                                        <OverlayTrigger
                                          overlay={
                                            <Tooltip id="tooltip-436082023">
                                              {" "}
                                              Edit{" "}
                                            </Tooltip>
                                          }
                                          placement="left"
                                        >
                                          <Button
                                            className="btn-link btn-icon"
                                            type="button"
                                            variant="success"
                                            onClick={() => {
                                              setSlider(slider);
                                              isAddViewEdit(slider.id, 3);
                                            }}
                                          >
                                            <FaEdit />
                                          </Button>
                                        </OverlayTrigger>
                                      </li>
                                    )}
                                    {permissions &&
                                      permissions.deleteSlider && (
                                        <li className="d-inline-block align-top">
                                          <OverlayTrigger
                                            overlay={
                                              <Tooltip id="tooltip-436082023">
                                                Delete
                                              </Tooltip>
                                            }
                                            placement="left"
                                          >
                                            <button
                                              type="button"
                                              className="btn-link btn-icon btn btn-danger"
                                              onClick={() => {
                                                deleteHandler(slider.id);
                                              }}
                                            >
                                              <FaTrash />
                                            </button>
                                          </OverlayTrigger>
                                        </li>
                                      )}
                                  </ul>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="13" className="text-center">
                              <div className="alert alert-info" role="alert">
                                No Slider Found
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                    {pagination && (
                      <Pagination
                        className="m-3"
                        defaultCurrent={1}
                        pageSize // items per page
                        current={pagination.page} // current active page
                        total={pagination.pages} // total pages
                        onChange={onPageChange}
                        locale={localeInfo}
                      />
                    )}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <SliderModal
            modalType={modalType}
            setModalType={setModalType}
            modalCloseHandler={modalCloseHandler}
            openModal={openModal}
            setOpenModal={setOpenModal}
            slider={slider}
            setSlider={setSlider}
            submit={submit}
            sliderErrors={sliderErrors}
            setSliderErrors={setSliderErrors}
            fetchGallery={fetchGallery}
            fetchContent={fetchContent}
            imageView={imageView}
            contentTitle={contentTitle}
            fetchEvents={fetchEvents}
            eventTitle={eventTitle}
          />
          <GalleryModal
            isOpenModal={isGalleryOpenModal}
            setOpenModal={setGalleryOpenModal}
            setImage={setImage}
            gallery={gallery}
            pagination={galleryPagination}
            onPageChange={onGalleryPageChange}
            reset={galleryReset}
            applyFilters={applyGalleryFilters}
            filters={galleryFilters}
            setFilters={setGalleryFilters}
            resetButton={galleryResetButton}
          />
          <ContentModal
            isOpenModal={isContentOpenModal}
            setOpenModal={setContentOpenModal}
            setContent={setContentFn}
            content={content}
            pagination={contentPagination}
            onPageChange={onContentPageChange}
            reset={contentReset}
            applyFilters={applyContentFilters}
            filters={contentFilters}
            setFilters={setContentFilters}
            resetButton={contentResetButton}
          />
          <EventModal
            isOpenModal={isEventOpenModal}
            setOpenModal={setEventOpenModal}
            setEvent={setEventFn}
            events={eventsData?.events || []}
            pagination={eventsData?.pagination || null}
            onPageChange={onEventPageChange}
            reset={eventReset}
            applyFilters={applyEventFilters}
            filters={eventFilters}
            setFilters={setEventFilters}
            resetButton={eventResetButton}
          />
        </Container>
    </>
  );
};

export default Slider;
